









































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import DateTimePicker from './DateTimePicker.vue';
import { request } from '@/rest-client';
import { AxiosResponse, AxiosError } from 'axios';
import RequestsService from '@/mixins/requests.service';
import UsersService from '@/mixins/users.service';
import CurrentUserService from '@/mixins/currentUser.service';
import { RequestStatusId, LeaveTypeId, Request } from '@/types/request';
import RequestsTable from '../Requests/RequestsTable.vue';

@Component({
  components: {
    DateTimePicker,
  },
  mixins: [ RequestsService, UsersService, CurrentUserService ],
})
export default class ModalPopup extends Mixins(RequestsService, UsersService, CurrentUserService) {
  private valid: boolean = false;

  private submitRequest(status: RequestStatusId) {
    if (this.globalLoading) { return; }
    const r = this.requestForm;
    request(r.id ? 'put' : 'post', `requests${ r.id ? '/' + r.id : ''}`, {
      ...r,
      reason: r.reason ? r.reason : '',
      id: r.id ? r.id : undefined,
    })
    .then((response: AxiosResponse) => {
      this.$store.dispatch('requests/updateRequests').then(() => this.closeModal());
    })
    .catch((error: any) => {
      (this.$root as any).showSnackbar((error as any).data.join(','), 'error');
    });
  }

  private closeModal(): void {
    this.valid = false;
    this.$store.dispatch('addEditRequest/resetBuilder');
  }

  private updateFormField(event: string, field: string) {
    this.$store.commit('addEditRequest/updateField', {[field]: event});
  }

  get filteredRequestStasuses(): any[] {
    return this.requestStatuses;
  }

  get requestForm(): Request {
    return this.$store.getters['addEditRequest/form'];
  }

  get globalLoading(): Request {
    return this.$store.getters.globalLoading;
  }

  get showModal(): boolean {
    return this.$store.getters['addEditRequest/showModal'];
  }

}
